// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import config from '../Common/Configurations/APIConfig'; 
// import DefaultData from '../Common/CompanyData/DefaultData'; // Import the DefaultData
// import './AdminDashboard.css';

// function AdminDashboard() {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
  
//   // Data States
//   const [salons, setSalons] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [orders, setOrders] = useState([]); 
//   const [todaysOrders, setTodaysOrders] = useState([]); 
//   const [upcomingCount, setUpcomingCount] = useState(0); 
//   const [totalAppointments, setTotalAppointments] = useState(0); 
//   const [todaysAppointments, setTodaysAppointments] = useState([]);
//   const [todaysSalons, setTodaysSalons] = useState([]); 
//   const [recentActivities, setRecentActivities] = useState([]);

//   // UI States
//   const [selectedSalon, setSelectedSalon] = useState(null);
//   const [showModal, setShowModal] = useState(false);
  
//   // Get currency from DefaultData
//   const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   const getStatusStyle = (status) => {
//     const s = status?.toUpperCase();
//     if (s === 'CANCELLED') return { color: '#dc3545', text: 'Cancelled' };
//     if (s === 'PENDING') return { color: '#ffc107', text: 'Pending' };
//     return { color: '#198754', text: status || 'Confirmed' };
//   };

//   const fetchDashboardData = async () => {
//     try {
//       setLoading(true);
      
//       const [salonRes, customerRes, productRes, appointmentRes, orderRes] = await Promise.all([
//         axios.get(config.APIACTIVEURL + config.GETALLSALON).catch(() => ({ data: [] })),
//         axios.get(config.APIACTIVEURL + config.GETALLCUSTOMER).catch(() => ({ data: [] })),
//         axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS).catch(() => ({ data: [] })),
//         axios.get(config.APIACTIVEURL + config.GETALLAPPOINTMENTS).catch(() => ({ data: [] })),
//         axios.get(config.APIACTIVEURL + config.GETALLORDERS).catch(() => ({ data: [] }))
//       ]);

//       const extractData = (res) => {
//           if (Array.isArray(res.data)) return res.data;
//           if (res.data && Array.isArray(res.data.data)) return res.data.data;
//           if (res.data && Array.isArray(res.data.items)) return res.data.items;
//           return [];
//       };

//       const salonData = extractData(salonRes);
//       const customerData = extractData(customerRes);
//       const productData = extractData(productRes);
//       const allAppointments = extractData(appointmentRes);
//       const allOrders = extractData(orderRes);

//       setSalons(salonData);
//       setCustomers(customerData);
//       setProducts(productData); 
//       setOrders(allOrders);
//       setTotalAppointments(allAppointments.length);

//       const now = new Date();
//       const todayStr = now.toDateString();

//       // Filter Today's Lists
//       const dailyOrders = allOrders.filter(o => o.createdAt && new Date(o.createdAt).toDateString() === todayStr);
//       setTodaysOrders(dailyOrders);

//       const dailyAppts = allAppointments.filter(a => new Date(a.startTime).toDateString() === todayStr);
//       setTodaysAppointments(dailyAppts);

//       const dailySalons = salonData.filter(s => s.createdAt && new Date(s.createdAt).toDateString() === todayStr);
//       setTodaysSalons(dailySalons);

//       const upcoming = allAppointments.filter(app => new Date(app.startTime) >= now);
//       setUpcomingCount(upcoming.length);

//       const activities = allAppointments.slice(0, 5).map((app, index) => ({
//         id: index,
//         salon: app.salon?.name || "Salon",
//         action: `Booked for ${app.customerName || app.user?.name || 'Customer'}`,
//         time: app.startTime ? new Date(app.startTime).toLocaleDateString() : "Recently",
//       }));
//       setRecentActivities(activities);
      
//     } catch (error) { console.error(error); } 
//     finally { setLoading(false); }
//   };

//   const handleOpenSalonDetails = (salon) => {
//     setSelectedSalon(salon);
//     setShowModal(true);
//   };
  
//   // Format currency with NGN
//   const formatCurrency = (amount) => {
//     return `${currency} ${amount?.toFixed(2) || '0.00'}`;
//   };

//   if (loading) {
//     return (
//       <div className="admin-loading-wrapper">
//         <div className="spinner-border text-success" role="status"></div>
//         <p className="mt-2 fw-bold text-success">Loading  Data...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="admin-dashboard-page-wrapper">
      
//       {/* 1. HEADER */}
//       <div className="dashboard-header-card shadow-sm border-0 mb-4">
//         <div className="row align-items-center g-3">
//           <div className="col-xl-4 col-lg-4 col-md-12">
//             <div className="d-flex align-items-center">
//               <div className="brand-icon-square me-3"><i className="ri-dashboard-fill"></i></div>
//               <div>
//                 <h3 className="fw-bold mb-0 text-dark">Admin Dashboard</h3>
//                 <p className="text-muted small mb-0">Operational Overview • MunnyFinds</p>
//               </div>
//             </div>
//           </div>
//           <div className="col-xl-5 col-lg-5 col-md-12">
//             <div className="metrics-container-pill border">
//               <div className="m-pill-item"><span className="m-pill-label">Salons</span><span className="m-pill-value">{salons.length}</span></div>
//               <div className="m-pill-divider"></div>
//               <div className="m-pill-item"><span className="m-pill-label">Total Appointments</span><span className="m-pill-value">{totalAppointments}</span></div>
//               <div className="m-pill-divider"></div>
//               <div className="m-pill-item"><span className="m-pill-label">Upcoming</span><span className="m-pill-value text-primary">{upcomingCount}</span></div>
//             </div>
//           </div>
//           <div className="col-xl-3 col-lg-3 text-lg-end text-center d-flex align-items-center justify-content-lg-end justify-content-center">
//             <button className="btn btn-primary-admin rounded-pill px-4 py-2 fw-bold shadow-sm" onClick={() => navigate('/salons')}>
//               Register Salon
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* 2. STAT CARDS */}
//       <div className="row g-4 mb-4">
//         {[
//           { title: "Total Orders", val: orders.length, icon: "ri-shopping-cart-2-line", col: "#065f46" },
//           { title: "Customers", val: customers.length, icon: "ri-user-heart-line", col: "#2563eb" },
//           { title: "Products", val: products.length, icon: "ri-shopping-bag-3-line", col: "#d97706" } 
//         ].map((s, i) => (
//           <div key={i} className="col-md-4" onClick={() => s.title === "Total Orders" && navigate('/admin/orders')} style={{cursor: 'pointer'}}>
//             <div className="stat-card-modern shadow-sm border-0" style={{ '--accent-color': s.col }}>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <p className="text-muted small fw-bold text-uppercase mb-1">{s.title}</p>
//                   <h2 className="fw-bold mb-0">{s.val}</h2>
//                 </div>
//                 <div className="stat-icon-bg" style={{ backgroundColor: `${s.col}15`, color: s.col }}><i className={s.icon}></i></div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="row g-4">
//         {/* 3. TODAY'S APPOINTMENTS TABLE */}
//         <div className="col-lg-8">
//           <div className="content-panel-card shadow-sm border-0 h-100">
//             <div className="d-flex justify-content-between align-items-center mb-4 p-2">
//               <h5 className="fw-bold mb-0">Today's Appointments</h5>
//               <span className="badge bg-soft-primary text-primary rounded-pill px-3">
//                 {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}
//               </span>
//             </div>
//             <div className="table-responsive">
//               <table className="table table-hover align-middle">
//                 <thead className="bg-light">
//                   <tr className="small text-muted text-uppercase">
//                     <th className="ps-3">Customer</th>
//                     <th>Salon</th>
//                     <th>Time</th>
//                     <th className="text-end pe-3">Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {todaysAppointments.length > 0 ? todaysAppointments.map((app, index) => {
//                     const statusInfo = getStatusStyle(app.status); 
//                     return (
//                       <tr key={index}>
//                         <td className="ps-3 py-3 fw-bold text-dark">{app.customerName || app.user?.name || 'Walk-in'}</td>
//                         <td className="small">{app.salon?.name || 'Salon'}</td>
//                         <td><span className="badge bg-light text-dark fw-normal">{new Date(app.startTime).toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'})}</span></td>
//                         <td className="text-end pe-3"><span className="small fw-bold" style={{ color: statusInfo.color }}>{statusInfo.text}</span></td>
//                       </tr>
//                     )
//                   }) : (<tr><td colSpan="4" className="text-center py-5 text-muted">No appointments today.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* 4. SIDEBAR AREA */}
//         <div className="col-lg-4">
          
//           {/* TODAY'S ORDERS CARD */}
//           <div className="content-panel-card shadow-sm border-0 mb-4">
//             <h6 className="fw-bold mb-3"><i className="ri-shopping-cart-line text-success me-2"></i> Today's Orders</h6>
//             <div className="today-orders-list">
//                 {todaysOrders.length > 0 ? todaysOrders.map((order, idx) => (
//                 <div key={idx} className="p-2 mb-1 bg-light rounded-3 border-start border-4 border-success shadow-sm">
//                     <div className="fw-bold text-dark text-truncate" style={{ fontSize: '0.75rem' }}>
//                         {order.product?.productName || "MunnyFinds Product"}
//                     </div>
//                     <div className="text-muted d-flex justify-content-between align-items-center" style={{fontSize: '0.65rem'}}>
//                         <span>{order.user?.name || "Customer"}</span>
//                         <span className="fw-bold text-dark">{formatCurrency(order.totalAmount)}</span>
//                     </div>
//                 </div>
//                 )) : <div className="text-center py-3 small text-muted">No orders placed today.</div>}
//             </div>
//           </div>

//           {/* NEW SALONS CARD */}
//           <div className="content-panel-card shadow-sm border-0 mb-4">
//             <h6 className="fw-bold mb-3"><i className="ri-store-2-line text-warning me-2"></i> New Salons Registered</h6>
//             {todaysSalons.map((salon, idx) => (
//               <div key={idx} className="d-flex justify-content-between align-items-center p-2 mb-2 bg-light rounded-3">
//                 <span className="small fw-bold text-dark">{salon.name}</span>
//                 <button className="btn btn-sm btn-outline-primary border-0 rounded-circle" onClick={() => handleOpenSalonDetails(salon)}>
//                     <i className="ri-eye-line"></i>
//                 </button>
//               </div>
//             ))}
//             {todaysSalons.length === 0 && <p className="text-muted small">No new salons today.</p>}
//           </div>

//           {/* RECENT ACTIVITY */}
//           <div className="content-panel-card shadow-sm border-0">
//             <h6 className="fw-bold mb-3"><i className="ri-history-line text-primary me-2"></i> Recent Activity</h6>
//             {recentActivities.map(activity => (
//               <div key={activity.id} className="activity-item ps-3 mb-3" style={{borderLeft: '2px solid #e2e8f0'}}>
//                 <div className="fw-bold small text-dark">{activity.salon}</div>
//                 <div className="text-muted" style={{ fontSize: '0.7rem' }}>{activity.action}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* --- SALON DETAIL MODAL --- */}
//       {showModal && selectedSalon && (
//         <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
//           <div className="modal-dialog modal-dialog-centered modal-lg">
//             <div className="modal-content border-0 shadow-lg rounded-4">
//               <div className="modal-header border-0 bg-light p-4 rounded-top-4">
//                 <div className="d-flex align-items-center">
//                    <div className="bg-primary text-white rounded-circle p-2 me-3" style={{width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
//                       <i className="ri-store-2-fill fs-5"></i>
//                    </div>
//                    <div>
//                       <h5 className="modal-title fw-bold mb-0">{selectedSalon.name}</h5>
//                       <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill small px-2">Active Partner</span>
//                    </div>
//                 </div>
//                 <button type="button" className="btn-close shadow-none" onClick={() => setShowModal(false)}></button>
//               </div>
              
//               <div className="modal-body p-4">
//                 <div className="row g-4 text-start">
//                   <div className="col-md-6">
//                     <h6 className="text-primary fw-bold mb-3 border-bottom pb-2">Business Contact</h6>
//                     <div className="mb-3">
//                       <label className="text-muted small text-uppercase fw-bold d-block">Owner / Manager</label>
//                       <p className="text-dark fw-medium mb-0">{selectedSalon.ownerName || 'Not Mentioned'}</p>
//                     </div>
//                     <div className="mb-3">
//                       <label className="text-muted small text-uppercase fw-bold d-block">Phone Number</label>
//                       <p className="text-dark fw-medium mb-0"><i className="ri-phone-line text-muted me-1"></i> {selectedSalon.phoneNumber || selectedSalon.phone || 'N/A'}</p>
//                     </div>
//                     <div className="mb-3">
//                       <label className="text-muted small text-uppercase fw-bold d-block">Email Address</label>
//                       <p className="text-dark fw-medium mb-0"><i className="ri-mail-line text-muted me-1"></i> {selectedSalon.email || 'N/A'}</p>
//                     </div>
//                   </div>

//                   <div className="col-md-6">
//                     <h6 className="text-primary fw-bold mb-3 border-bottom pb-2">Salon Info</h6>
//                     <div className="mb-3">
//                       <label className="text-muted small text-uppercase fw-bold d-block">Category</label>
//                       <span className="badge bg-light text-dark fw-medium border px-3">{selectedSalon.category || 'General Beauty'}</span>
//                     </div>
//                     <div className="mb-3">
//                       <label className="text-muted small text-uppercase fw-bold d-block">Registration Date</label>
//                       <p className="text-dark small mb-0">{new Date(selectedSalon.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
//                     </div>
//                   </div>

//                   <div className="col-12">
//                     <div className="bg-light p-3 rounded-3 border border-dashed">
//                       <label className="text-muted small text-uppercase fw-bold d-block mb-1">Location Address</label>
//                       <p className="mb-0 text-dark">
//                         <i className="ri-map-pin-2-fill text-danger me-2"></i>
//                         {selectedSalon.address || 'Address information missing.'}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer border-0 p-4">
//                 <button className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setShowModal(false)}>Close Window</button>
//                 <button className="btn btn-primary rounded-pill px-4" onClick={() => navigate(`/salons`)}>
//                   Manage Business <i className="ri-arrow-right-line ms-1"></i>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default AdminDashboard;

//web view 

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../Common/Configurations/APIConfig'; 
import DefaultData from '../Common/CompanyData/DefaultData'; 
import './AdminDashboard.css';

function AdminDashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  // Data States
  const [salons, setSalons] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]); 
  const [todaysOrders, setTodaysOrders] = useState([]); 
  const [upcomingCount, setUpcomingCount] = useState(0); 
  const [totalAppointments, setTotalAppointments] = useState(0); 
  const [todaysAppointments, setTodaysAppointments] = useState([]);
  const [todaysSalons, setTodaysSalons] = useState([]); 
  const [recentActivities, setRecentActivities] = useState([]);

  // UI States
  const [selectedSalon, setSelectedSalon] = useState(null);
  const [showModal, setShowModal] = useState(false);
  
  // Get currency from DefaultData
  const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const getStatusStyle = (status) => {
    const s = status?.toUpperCase();
    if (s === 'CANCELLED') return { color: '#dc3545', text: 'Cancelled' };
    if (s === 'PENDING') return { color: '#ffc107', text: 'Pending' };
    return { color: '#198754', text: status || 'Confirmed' };
  };

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      
      const [salonRes, customerRes, productRes, appointmentRes, orderRes] = await Promise.all([
        axios.get(config.APIACTIVEURL + config.GETALLSALON).catch(() => ({ data: [] })),
        axios.get(config.APIACTIVEURL + config.GETALLCUSTOMER).catch(() => ({ data: [] })),
        axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS).catch(() => ({ data: [] })),
        axios.get(config.APIACTIVEURL + config.GETALLAPPOINTMENTS).catch(() => ({ data: [] })),
        axios.get(config.APIACTIVEURL + config.GETALLORDERS).catch(() => ({ data: [] }))
      ]);

      const extractData = (res) => {
          if (Array.isArray(res.data)) return res.data;
          if (res.data && Array.isArray(res.data.data)) return res.data.data;
          if (res.data && Array.isArray(res.data.items)) return res.data.items;
          return [];
      };

      const salonData = extractData(salonRes);
      const customerData = extractData(customerRes);
      const productData = extractData(productRes);
      const allAppointments = extractData(appointmentRes);
      const allOrders = extractData(orderRes);

      setSalons(salonData);
      setCustomers(customerData);
      setProducts(productData); 
      setOrders(allOrders);
      setTotalAppointments(allAppointments.length);

      const now = new Date();
      const todayStr = now.toDateString();

      // Filter Today's Lists
      const dailyOrders = allOrders.filter(o => o.createdAt && new Date(o.createdAt).toDateString() === todayStr);
      setTodaysOrders(dailyOrders);

      const dailyAppts = allAppointments.filter(a => new Date(a.startTime).toDateString() === todayStr);
      setTodaysAppointments(dailyAppts);

      const dailySalons = salonData.filter(s => s.createdAt && new Date(s.createdAt).toDateString() === todayStr);
      setTodaysSalons(dailySalons);

      const upcoming = allAppointments.filter(app => new Date(app.startTime) >= now);
      setUpcomingCount(upcoming.length);

      const activities = allAppointments.slice(0, 5).map((app, index) => ({
        id: index,
        salon: app.salon?.name || "Salon",
        action: `Booked for ${app.customerName || app.user?.name || 'Customer'}`,
        time: app.startTime ? new Date(app.startTime).toLocaleDateString() : "Recently",
      }));
      setRecentActivities(activities);
      
    } catch (error) { console.error(error); } 
    finally { setLoading(false); }
  };

  const handleOpenSalonDetails = (salon) => {
    setSelectedSalon(salon);
    setShowModal(true);
  };
  
  const formatCurrency = (amount) => {
    return `${currency} ${amount?.toFixed(2) || '0.00'}`;
  };

  if (loading) {
    return (
      <div className="admin-loading-wrapper">
        <div className="spinner-border text-success" role="status"></div>
        <p className="mt-2 fw-bold text-success">Loading Data...</p>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-page-wrapper">
      
      {/* 1. HEADER - Responsive Grid Applied */}
      <div className="dashboard-header-card shadow-sm border-0 mb-4">
        <div className="row align-items-center g-3">
          <div className="col-12 col-xl-4 col-lg-4">
            <div className="d-flex align-items-center">
              <div className="brand-icon-square me-3"><i className="ri-dashboard-fill"></i></div>
              <div>
                <h3 className="fw-bold mb-0 text-dark dashboard-title">Admin Dashboard</h3>
                <p className="text-muted small mb-0">Operational Overview • MunnyFinds</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-5 col-lg-5">
            <div className="metrics-container-pill border">
              <div className="m-pill-item"><span className="m-pill-label">Salons</span><span className="m-pill-value">{salons.length}</span></div>
              <div className="m-pill-divider"></div>
              <div className="m-pill-item"><span className="m-pill-label"> Total Appointments</span><span className="m-pill-value">{totalAppointments}</span></div>
              <div className="m-pill-divider"></div>
              <div className="m-pill-item"><span className="m-pill-label">Upcoming Appointments</span><span className="m-pill-value text-primary">{upcomingCount}</span></div>
            </div>
          </div>
          <div className="col-12 col-xl-3 col-lg-3 text-lg-end text-center mt-3 mt-lg-0">
            <button className="btn btn-primary-admin rounded-pill px-4 py-2 fw-bold shadow-sm w-100-mobile" onClick={() => navigate('/salons')}>
              Register Salon
            </button>
          </div>
        </div>
      </div>

      {/* 2. STAT CARDS - Fixed stacking */}
      <div className="row g-3 g-md-4 mb-4">
        {[
          { title: "Total Orders", val: orders.length, icon: "ri-shopping-cart-2-line", col: "#065f46" },
          { title: "Customers", val: customers.length, icon: "ri-user-heart-line", col: "#2563eb" },
          { title: "Products", val: products.length, icon: "ri-shopping-bag-3-line", col: "#d97706" } 
        ].map((s, i) => (
          <div key={i} className="col-12 col-md-4" onClick={() => s.title === "Total Orders" && navigate('/admin/orders')} style={{cursor: 'pointer'}}>
            <div className="stat-card-modern shadow-sm border-0" style={{ '--accent-color': s.col }}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="text-muted small fw-bold text-uppercase mb-1">{s.title}</p>
                  <h2 className="fw-bold mb-0">{s.val}</h2>
                </div>
                <div className="stat-icon-bg" style={{ backgroundColor: `${s.col}15`, color: s.col }}><i className={s.icon}></i></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        {/* 3. TODAY'S APPOINTMENTS TABLE - Table Responsive wrapper is key */}
        <div className="col-12 col-lg-8">
          <div className="content-panel-card shadow-sm border-0 h-100">
            <div className="d-flex justify-content-between align-items-center mb-4 p-2">
              <h5 className="fw-bold mb-0 panel-title">Today's Appointments</h5>
              <span className="badge bg-soft-primary text-primary rounded-pill px-3">
                {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}
              </span>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="bg-light">
                  <tr className="small text-muted text-uppercase">
                    <th className="ps-3">Customer</th>
                    <th>Salon</th>
                    <th>Time</th>
                    <th className="text-end pe-3">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {todaysAppointments.length > 0 ? todaysAppointments.map((app, index) => {
                    const statusInfo = getStatusStyle(app.status); 
                    return (
                      <tr key={index}>
                        <td className="ps-3 py-3 fw-bold text-dark">{app.customerName || app.user?.name || 'Walk-in'}</td>
                        <td className="small">{app.salon?.name || 'Salon'}</td>
                        <td><span className="badge bg-light text-dark fw-normal">{new Date(app.startTime).toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'})}</span></td>
                        <td className="text-end pe-3"><span className="small fw-bold" style={{ color: statusInfo.color }}>{statusInfo.text}</span></td>
                      </tr>
                    )
                  }) : (<tr><td colSpan="4" className="text-center py-5 text-muted">No appointments today.</td></tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* 4. SIDEBAR AREA */}
        <div className="col-12 col-lg-4">
          
          {/* TODAY'S ORDERS CARD */}
          <div className="content-panel-card shadow-sm border-0 mb-4">
            <h6 className="fw-bold mb-3"><i className="ri-shopping-cart-line text-success me-2"></i> Today's Orders</h6>
            <div className="today-orders-list">
                {todaysOrders.length > 0 ? todaysOrders.map((order, idx) => (
                <div key={idx} className="p-2 mb-1 bg-light rounded-3 border-start border-4 border-success shadow-sm">
                    <div className="fw-bold text-dark text-truncate" style={{ fontSize: '0.75rem' }}>
                        {order.product?.productName || "MunnyFinds Product"}
                    </div>
                    <div className="text-muted d-flex justify-content-between align-items-center" style={{fontSize: '0.65rem'}}>
                        <span>{order.user?.name || "Customer"}</span>
                        <span className="fw-bold text-dark">{formatCurrency(order.totalAmount)}</span>
                    </div>
                </div>
                )) : <div className="text-center py-3 small text-muted">No orders placed today.</div>}
            </div>
          </div>

          {/* NEW SALONS CARD */}
          <div className="content-panel-card shadow-sm border-0 mb-4">
            <h6 className="fw-bold mb-3"><i className="ri-store-2-line text-warning me-2"></i> New Salons</h6>
            {todaysSalons.map((salon, idx) => (
              <div key={idx} className="d-flex justify-content-between align-items-center p-2 mb-2 bg-light rounded-3">
                <span className="small fw-bold text-dark text-truncate me-2">{salon.name}</span>
                <button className="btn btn-sm btn-outline-primary border-0 rounded-circle" onClick={() => handleOpenSalonDetails(salon)}>
                    <i className="ri-eye-line"></i>
                </button>
              </div>
            ))}
            {todaysSalons.length === 0 && <p className="text-muted small">No new salons today.</p>}
          </div>

          {/* RECENT ACTIVITY */}
          <div className="content-panel-card shadow-sm border-0">
            <h6 className="fw-bold mb-3"><i className="ri-history-line text-primary me-2"></i> Recent Activity</h6>
            {recentActivities.map(activity => (
              <div key={activity.id} className="activity-item ps-3 mb-3" style={{borderLeft: '2px solid #e2e8f0'}}>
                <div className="fw-bold small text-dark">{activity.salon}</div>
                <div className="text-muted" style={{ fontSize: '0.7rem' }}>{activity.action}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* --- SALON DETAIL MODAL --- */}
      {showModal && selectedSalon && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
          <div className="modal-dialog modal-dialog-centered modal-lg mx-2 mx-md-auto">
            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
              <div className="modal-header border-0 bg-light p-3 p-md-4">
                <div className="d-flex align-items-center">
                   <div className="bg-primary text-white rounded-circle p-2 me-3 d-none d-md-flex" style={{width: '45px', height: '45px', alignItems: 'center', justifyContent: 'center'}}>
                      <i className="ri-store-2-fill fs-5"></i>
                   </div>
                   <div>
                      <h5 className="modal-title fw-bold mb-0 h6-mobile">{selectedSalon.name}</h5>
                      <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill extra-small px-2">Active Partner</span>
                   </div>
                </div>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowModal(false)}></button>
              </div>
              
              <div className="modal-body p-3 p-md-4">
                <div className="row g-3 g-md-4 text-start">
                  <div className="col-12 col-md-6">
                    <h6 className="text-primary fw-bold mb-2 mb-md-3 border-bottom pb-2 small">Business Contact</h6>
                    <div className="mb-2 mb-md-3">
                      <label className="text-muted extra-small text-uppercase fw-bold d-block">Owner / Manager</label>
                      <p className="text-dark fw-medium mb-0 small">{selectedSalon.ownerName || 'Not Mentioned'}</p>
                    </div>
                    <div className="mb-2 mb-md-3">
                      <label className="text-muted extra-small text-uppercase fw-bold d-block">Phone Number</label>
                      <p className="text-dark fw-medium mb-0 small"><i className="ri-phone-line text-muted me-1"></i> {selectedSalon.phoneNumber || selectedSalon.phone || 'N/A'}</p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <h6 className="text-primary fw-bold mb-2 mb-md-3 border-bottom pb-2 small">Salon Info</h6>
                    <div className="mb-2 mb-md-3">
                      <label className="text-muted extra-small text-uppercase fw-bold d-block">Category</label>
                      <span className="badge bg-light text-dark fw-medium border px-3 small">{selectedSalon.category || 'General Beauty'}</span>
                    </div>
                    <div className="mb-2 mb-md-3">
                      <label className="text-muted extra-small text-uppercase fw-bold d-block">Registration Date</label>
                      <p className="text-dark extra-small mb-0">{new Date(selectedSalon.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="bg-light p-2 p-md-3 rounded-3 border border-dashed">
                      <label className="text-muted extra-small text-uppercase fw-bold d-block mb-1">Location Address</label>
                      <p className="mb-0 text-dark small">
                        <i className="ri-map-pin-2-fill text-danger me-2"></i>
                        {selectedSalon.address || 'Address information missing.'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer border-0 p-3 p-md-4">
                <button className="btn btn-outline-secondary rounded-pill px-3 px-md-4 small" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary rounded-pill px-3 px-md-4 small" onClick={() => navigate(`/salons`)}>
                  Manage Business <i className="ri-arrow-right-line ms-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminDashboard;